<template>
    <modal
        name="update-operator-modal"
        :classes="'customModal'"
        :scrollable="true"
        :reset="true"
        :adaptive="false"
        :width="650"
        height="auto"
        @before-open="getData"
        @closed="closeModal()"
    >
        <div class="modalWrapper">
            <form @submit.prevent="updateOperator()">
                <div class="content__box">
                    <div class="content__box__header">
                        <p class="text-white txt--ss opacity--50">Update Operator</p>
                    </div>
                    <div class="content__divider"></div>
                    <div class="content__box__body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form__group mb-3">
                                    <label class="txt--xs txt--off-white">Email</label
                                    ><input
                                    type="text"
                                    placeholder="Enter email"
                                    class="textInputField"
                                    maxlength="50"
                                    v-model.trim="operator.email"
                                    :disabled="email_update_disabled"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-between
                                            flex-wrap
                                            mb-2
                                        "
                                    >
                                        <p class="txt--xs txt--off-white">Property Access</p>

                                        <app-toggle label="All properties" :key="property_component_id" :checked="all_property_access" @update:checked="getCheckedStatus($event, 'all_property_access')"></app-toggle>
                                    </div>

                                    <multi-list-select
                                        :list="property_list"
                                        :selected-items="selected_property_ids"
                                        option-value="space_id"
                                        option-text="property_name"
                                        placeholder="select properties"
                                        class="custom-vue-select"
                                        @select="onSelect"
                                    ></multi-list-select>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group d-flex align-items-center">
                                    <app-toggle
                                    :checked="report_access"
                                    :key="report_key"
                                    :label="'Report Access'"
                                    @update:checked="getCheckedStatus($event, 'report_access')"
                                    ></app-toggle>
                                    <span class="text-white txt--ss opacity--50" v-if="report_access">
                                        <input type="checkbox" v-model="report_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                                        <input type="checkbox" v-model="report_access_write" value="1" class="cursor-pointer ml-3"/> Write
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <app-toggle
                                    :checked="audit_access"
                                    :key="audit_key"
                                    :label="'Audit Access'"
                                    @update:checked="getCheckedStatus($event, 'audit_access')"
                                    ></app-toggle>
                                </div>
                            </div> -->
                            <div class="col-md-12">
                                <div class="form-group d-flex align-items-center">
                                    <app-toggle
                                    :checked="permit_access"
                                    :key="permit_key"
                                    :label="'Permit Access'"
                                    @update:checked="getCheckedStatus($event, 'permit_access')"
                                    ></app-toggle>
                                    <span class="text-white txt--ss opacity--50" v-if="permit_access">
                                        <input type="checkbox" v-model="permit_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                                        <input type="checkbox" v-model="permit_access_write" value="1" class="cursor-pointer ml-3"/> Write
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group d-flex align-items-center">
                                    <app-toggle
                                    :checked="invitation_access"
                                    :key="invitation_key"
                                    :label="'Invitation Access'"
                                    @update:checked="getCheckedStatus($event, 'invitation_access')"
                                    ></app-toggle>
                                    <span class="text-white txt--ss opacity--50" v-if="invitation_access">
                                        <input type="checkbox" v-model="invitation_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                                        <input type="checkbox" v-model="invitation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group d-flex align-items-center">
                                    <app-toggle
                                    :checked="validation_access"
                                    :key="validation_key"
                                    :label="'Validation Access'"
                                    @update:checked="getCheckedStatus($event, 'validation_access')"
                                    ></app-toggle>
                                    <span class="text-white txt--ss opacity--50" v-if="validation_access">
                                        <input type="checkbox" v-model="validation_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                                        <input type="checkbox" v-model="validation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="col-md-12">
                                <div class="form-group text-white txt--ss opacity--50">
                                    <input 
                                        type="checkbox" 
                                        v-model="read_access"
                                        class="cursor-pointer" 
                                        checked disabled /> Read
                                    <input 
                                        type="checkbox" 
                                        v-model="write_access"
                                        class="cursor-pointer ml-3"/> Write
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center flex-wrap mt-4">
                    <ButtonWithSpinner
                        class="button button--primary button--sm mr-3"
                        type="submit"
                        :disabled="button.disabled"
                        :loading="button.loading"
                        :success="button.success"
                    >
                       Update
                    </ButtonWithSpinner >
                    <button
                        type="button"
                        class="button button--outline button--sm"
                        @click="closeModal()"
                    >
                    Cancel
                    </button>
                </div>
            </form>
            <div class="session__modal__close" @click="closeModal()">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </modal>
</template>
<script>
import Toggle from "@/components/toggle";
import { MultiListSelect  } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
export default {
    components: {
        AppToggle: Toggle,
        MultiListSelect,
        ButtonWithSpinner 
    },
    data() {
        return {
            operator:{},
            email: '',
            email_update_disabled: false,
            property_component_id: +new Date(),
            all_property_access: false,
            property_list: [],
            property_access_list: [],
            selected_property_ids: [],
            lastSelectProperty: '',
            report_access: false, 
            report_key:+new Date(),
            audit_access: false,
            audit_key: +new Date(),
            permit_access : false,
            permit_key: +new Date(),
            invitation_access: false,
            invitation_key: +new Date(),
            validation_access: false,
            validation_key: +new Date(),
            button: {
                success: false,
                disabled: false,
                loading: false,
            },
            // read_access:  true,
            // write_access: false,

            report_access_read:         true,
            report_access_write:        false,
            permit_access_read:         true,
            permit_access_write:        false,
            invitation_access_read:     true,
            invitation_access_write:    false,
            validation_access_read:     true,
            validation_access_write:    false,
        }
    },
    watch: {
        selected_property_ids : function(val) {
            if(val.length == this.property_list.length) {
                this.all_property_access = true;
                this.property_component_id++;
            }
            else {
                this.property_component_id++;
                this.all_property_access = false;
            }
        }
    },
    methods: {
        resetData(){
            this.operator = {};
            this.email = '';
            this.property_component_id = +new Date();
            this.all_property_access = false;
            this.property_list = [];
            this.property_access_list = [];
            this.selected_property_ids = [];
            this.lastSelectProperty = '';
            this.report_access = false; 
            this.report_key = +new Date();
            this.audit_access = false;
            this.audit_key = +new Date();
            this.permit_access = false;
            this.permit_key = +new Date();
            this.invitation_access = false;
            this.invitation_key = +new Date();
            this.validation_access = false;
            this.validation_key = +new Date();
            this.readWrite_access   = false;
            this.readWrite_key      = 1;
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;
        },
        closeModal() {
            this.resetData();
            this.$modal.hide('update-operator-modal');
        },
        getData(e) {
            this.operator = e.params.operator;
            // console.log(this.operator.write_permission);
            if(e.params.tab=='operator') {
                this.email_update_disabled = true;
            }
            else {
                this.email_update_disabled = false;
            }
            let property_list = [];
            property_list= e.params.property_list;
            property_list.map(val=> {
                let property = {
                    space_id : val.space_id,
                    property_name: val.property_name!=''? val.property_name : val.address
                }
                this.property_list.push(property);
            });

            this.all_property_access = this.operator.access_permissions.all_property_access;

            let property_access_list = [];
            property_access_list= this.operator.access_permissions.property_access_list;
            property_access_list.map(val=> {
                let property = {
                    space_id : val.property_id,
                    property_name: val.property_name!=''? val.property_name : val.address
                }
                this.property_access_list.push(property);
            });
              
            if(this.all_property_access) {
                this.selected_property_ids = this.property_list;
            }
            else {
                this.selected_property_ids =  this.property_access_list;
            }
            
            this.report_access = this.operator.access_permissions.report_access;
           
            this.audit_access = this.operator.access_permissions.audit_access;
            
            this.permit_access = this.operator.access_permissions.permit_access;

            this.invitation_access = this.operator.access_permissions.invitation_access;

            this.validation_access = this.operator.access_permissions.validation_access;

            this.validation_access_read         = this.operator.access_permissions.validation_access_read;
            this.validation_access_write        = this.operator.access_permissions.validation_access_write;
            this.invitation_access_read         = this.operator.access_permissions.invitation_access_read;
            this.invitation_access_write        = this.operator.access_permissions.invitation_access_write;
            this.permit_access_read             = this.operator.access_permissions.permit_access_read;
            this.permit_access_write            = this.operator.access_permissions.permit_access_write;
            this.report_access_read             = this.operator.access_permissions.report_access_read;
            this.report_access_write            = this.operator.access_permissions.report_access_write;
        },
        onSelect (items, lastSelectItem) {
            this.selected_property_ids = items
            this.lastSelectProperty = lastSelectItem
        },
        getCheckedStatus(checked, type) {
            if(type == 'all_property_access') {
                this.all_property_access = checked;
                if(this.all_property_access) {
                    this.selected_property_ids = this.property_list;
                }
                else {
                    this.selected_property_ids = [];
                }
            }
            else if(type == 'report_access') {
                this.report_access = checked;
            }
            else if(type == 'audit_access') {
                this.audit_access = checked;
            }
            else if(type == 'permit_access') {
                this.permit_access = checked;
            }
            else if(type=='invitation_access') {
                this.invitation_access = checked;
            }
            else if(type=='validation_access') {
                this.validation_access = checked;
            }
        },
        updateOperator() {
            if(this.operator.email == '') {
                this.$toasted.show("Please provide an email!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }

            let form = {};
            form.operator_relation_id =  this.operator.id;
            form.email = this.operator.email;
            form.property_access = this.selected_property_ids.map((val)=> { return val.space_id });
            form.all_property_access = this.all_property_access;
            form.report_access = this.report_access;
            form.permit_access = this.permit_access;
            form.audit_access = 0;
            form.invitation_access = this.invitation_access;
            form.validation_access = this.validation_access;

            form.report_access_read         =   this.report_access_read         == true ? 1 : 0,
            form.report_access_write        =   this.report_access_write        == true ? 1 : 0,
            form.permit_access_read         =   this.permit_access_read         == true ? 1 : 0,
            form.permit_access_write        =   this.permit_access_write        == true ? 1 : 0,
            form.invitation_access_read     =   this.invitation_access_read     == true ? 1 : 0,
            form.invitation_access_write    =   this.invitation_access_write    == true ? 1 : 0,
            form.validation_access_read     =   this.validation_access_read     == true ? 1 : 0,
            form.validation_access_write    =   this.validation_access_write    == true ? 1 : 0,

            this.button.disabled = true;
            this.button.loading = true;
            this.button.success = false;

            console.log(this.form);
            this.axios.post(window.hostname+'/api/auth/operator/update',form)
            .then(res=>{
                this.button.disabled = false;
                this.button.loading = false;
                if(res.data.status) {
                    this.button.success = true;
                    this.$toasted.show("Operator updated successfully!",{
                        icon: 'check-circle',
                        className: 'success-class'
                    });
                    this.operator.email = '';
                    this.selected_property_ids = [];
                    this.property_component_id++;
                    this.report_access = false;
                    this.report_key++;
                    this.audit_access = false;
                    this.audit_key++;
                    this.permit_access = false;
                    this.permit_key++;
                    this.invitation_access = false;
                    this.invitation_key++;
                    this.validation_access = false;
                    this.validation_key++;
                    // this.report_access_write        =   false;
                    // this.permit_access_write        =   false;
                    // this.invitation_access_write    =   false;
                    // this.validation_access_write    =   false;
                    
                    this.$emit("update_operator_list");                
                    this.closeModal();
                }
                else {
                    this.button.success = false;
                    this.$toasted.show(res.data.message,{
                        icon:'times-circle',
                        className: 'error-class'
                    });
                }
            })
            .catch(err=> {
                this.button.disabled = false;
                this.button.loading = false;
                this.button.success = false;
                this.$toasted.show(err.response.data.message,{
                    icon: 'times-circle',
                    className: 'error-class'
                });
            });
            
        }
    }
}
</script>
<style scoped>
    .switch--with--label{
        flex-basis: 30%;
    }
</style>